export default __webpack_public_path__ + "static/media/QSGA_Cells_Funcs02.b36f9196.png";